



import { QueryFunction } from '@tanstack/react-query';

import client, { apiClient } from '../lib/client';
import {
  AffiliateEarningsRes,
  GetAffiliateTransactionsRes,
  GetAffiliateProfileResponse,
  GetAffiliateCreditTransactionsResponse,
  GetAffiliateDebitTransactionsResponse,
  PhoneNumberResponse
} from '../lib/types';

export const getAffiliateEarnings: QueryFunction<AffiliateEarningsRes, [string, Record<string, any>]> = async context => {
  const { data } = await client.get(context.queryKey[0] as string);
  return data;
};

export const getAffiliateTransactions = async (
  affiliateId: string,
  queryParams: Record<string, any>,
  pageParam?: string
): Promise<GetAffiliateTransactionsRes> => {
  const { data } = await client.get(`/affiliate/v1/affiliates/${affiliateId}/transactions`, {
    params: {
      ...queryParams,
      ...(pageParam && {
        cursor: pageParam
      })
    }
  });
  return data;
};

export const getPhoneNumberByEmail = async (email: string): Promise<PhoneNumberResponse> => {
  try {
    const { data } = await apiClient.get('/affiliate/v1/affiliates/phone-number', {
      params: {
        email: email.trim()
      }
    });
    return data;
  } catch (error: any) {
    switch (error.response?.status) {
      case 400: {
        throw new Error('EmailRequiredError');
      }
      case 404: {
        throw new Error('UserNotFoundError');
      }
      case 403: {
        throw new Error('NotAffiliateError');
      }
      default: {
        throw new Error('Network error');
      }
    }
  }
};

export const updatePhoneNumber = async (newPhoneNumber: string): Promise<void> => {
  await client.put('/affiliate/v1/affiliates/phone-number', {
    newPhoneNumber
  });
};

export const completePhoneUpdate = async (): Promise<void> => {
  try {
    await client.post('/affiliate/v1/affiliates/complete-phone-update');
  } catch (error: any) {
    console.error('Failed to complete phone update:', error);
    throw error;
  }
};

export const getAffiliateProfile: QueryFunction<GetAffiliateProfileResponse, [string, Record<string, any>]> = async context => {
  const { data } = await client.get(context.queryKey[0] as string);
  return data;
};

export const getAffiliateCreditTransactions = async (
  queryParams: Record<string, any>
): Promise<GetAffiliateCreditTransactionsResponse> => {
  const { data } = await client.get('/affiliate/v2/portal/affiliate-credit-transactions', {
    params: queryParams
  });
  return data;
};

export const getAffiliateDebitTransactions = async (
  queryParams: Record<string, any>
): Promise<GetAffiliateDebitTransactionsResponse> => {
  const { data } = await client.get('/affiliate/v2/portal/affiliate-debit-transactions', {
    params: queryParams
  });
  return data;
};